<template>
    <nav id="post-pagination" class="post-pagination" :class="[$variables.post_pagination_link, $variables.post_pagination_style, {'pagination-lg': !is_mobile}]">
        <span class="post-pages text-center">{{ pageXofY }}</span>
        <paginate ref="post_pagination"
            :page-count="total_pages"
            :click-handler="pageCallback"
            :prev-text="previousText"
            :next-text="nextText"
            :page-range="range"
            :container-class="paginationClass"
            :page-class="'page-item'"
            :prev-class="'page-item'"
            :next-class="'page-item'"
            :page-link-class="'page-link'"
            :prev-link-class="'page-link'"
            :next-link-class="'page-link'"
            :force-page="current_page"
            :value="current_page"
        >
        </paginate>
    </nav>
</template>

<script>
import {isMobile} from 'mobile-device-detect';

export default {
    props: {
        store: {
            type: Object,
        },
    },
    computed: {
        is_mobile: function() {
            return isMobile
        },
        range: function () {
            return isMobile ? 1 : 3
        },
        paginationClass: function() {
            return this.$variables.post_pagination_link == 'page_xofy'? `pagination mt-4 justify-content-between` : 'pagination mt-4 justify-content-center'
        },
        previousText: function() {
            return this.$variables.post_pagination_labels === 'adjacent'? this.$t('i18n.previous') : (this.$variables.post_pagination_labels === 'adjacent_page'? this.$t('i18n.previousPage') : '&nbsp;')
        },
        nextText: function() {
            return this.$variables.post_pagination_labels === 'adjacent'? this.$t('i18n.next') : (this.$variables.post_pagination_labels === 'adjacent_page'? this.$t('i18n.nextPage') : '')
        },
        total_pages: function() {
            return this.store.state.total_pages
        },
        current_page: function() {
            return parseInt(this.store.state.page, 10)
        },
        pageXofY: function() {
            return this.$t('i18n.pageXofY', {x: this.current_page, y: this.total_pages})
        }
    },
    methods: {
        pageCallback(page) {
            let url = window.location.href.split('?')[0] + '?page=' + page
            if(!this.$variables.post_pagination_reload) {
                this.store.state.page = page
                window.history.pushState({}, "", url)
                $('html, body').animate({
                    scrollTop: 0
                }, 200);
            } else {
                window.location.replace(url);
            }
        }
    },
};
</script>